export const CONSONANT_VOWEL_PAIRS_SS = [

    // ㅆ
  {
        id: 1,
        korean: "싸",
        english: "ssa",

    },
    {
        id: 2,
        korean: "쎄",
        english: "sse",

    },
    {
        id: 3,
        korean: "씨",
        english: "ssi",

    },
    {
        id: 4,
        korean: "쏘",
        english: "sso",

    },
    {
        id: 5,
        korean: "쓰",
        english: "sseu",

    },
    {
        id: 6,
        korean: "써",
        english: "sseo",

    },
    {
        id: 7,
        korean: "쌰",
        english: "ssya",

    },
    {
        id: 8,
        korean: "쌔",
        english: "ssae",

    },
    {
        id: 9,
        korean: "쎼",
        english: "ssye",

    },
    {
        id: 10,
        korean: "쑈",
        english: "ssyo",

    },
    {
        id: 11,
        korean: "쎠",
        english: "ssyeo",

    },
    {
        id: 12,
        korean: "쓔",
        english: "ssyu",

        

    },

    {
        id: 13,
        korean: "싼",
        english: "ssan",

        

    },
    {
        id: 14,
        korean: "쌐",
        english: "ssak",

        

    },
    {
        id: 15,
        korean: "씸",
        english: "ssim",
        

    },
    {
        id: 16,
        korean: "쌑",
        english: "ssat",
        

    },
    {
        id: 17,
        korean: "쌓",
        english: "ssah",
        

    },
    {
        id: 18,
        korean: "썹",
        english: "sseob",
        

    },
          {
        id: 19,
        korean: "쓸",
        english: "sseul",
        

    },
    {
        id: 20,
        korean: "쌋",
        english: "ssat",
        

    },
    {
        id: 21,
        korean: "쌖",
        english: "ssaekk",
        

    },
    {
        id: 22,
        korean: "쌘",
        english: "ssaen",
        

    },
    {
        id: 23,
        korean: "씌",
        english: "ssui",
        

    },
    {
        id: 24,
        korean: "쒀",
        english: "sswo",
        

    },

    {
        id: 25,
        korean: "썉",
        english: "ssyat",
        

    },
    {
        id: 26,
        korean: "쌎",
        english: "ssat",
        

    },
    {
        id: 27,
        korean: "쌑",
        english: "ssat",
        
    },
    {
        id: 28,
        korean: "쌀",
        english: "ssal",
        
    },
    {
        id: 29,
        korean: "쌑",
        english: "ssat",
        
    },
    {
        id: 30,
        korean: "쌋",
        english: "ssat",
        
    },
    
    
    
];

